var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issue-info"},[(!_vm.isEmpty)?_c('div',{ref:"charts"}):_c('div',{staticClass:"notData"},[_c('img',{attrs:{"src":require("../../../../../assets/image/emptyRound.png")}}),_c('div',{staticClass:"notData-word"},[_vm._v("暂无数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }